<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header = "Información de la Marca">
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim= "$v.nombre.$model"
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons"
                    @click="seleccionarCliente">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !cliente,
                                  'fa fa-remove': cliente  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="cliente"
                  :value="clienteNombre"
                  :state="clienteValido"
                  readonly
                  type="text"/>
              </b-input-group>
              <b-form-invalid-feedback id="clienteFeedback">
                {{ clienteInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-for="inactivo"
              :label-cols="labelCols">
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'marca/getField',
  mutationType: 'marca/updateField',
});

export default {
  name: 'MarcasABM',
  components: {
    appSearchCliente: SearchCliente,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      clienteValido: null,
      clienteInvalidoMsj: '',

      labelCols: 1,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'cliente',
      'clienteNombre',
      'inactivo',
    ])
  },
  created() {
    let marcaId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        marcaId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('marca/inicializar', marcaId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "nombre" || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (this.$v.nombre.$error && !this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }      
          if (this.$v.nombre.$error && !this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre de la marca';
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true; 

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let clienteError = Boolean(true);
      if (this.cliente) {
        if (this.cliente.id) {
          if (this.cliente.id != 0) {
            clienteError = Boolean(false);
          }
        }
      }
      if (clienteError) {
        save = Boolean(false);
        this.clienteValido = false;
        this.clienteInvalidoMsj = 'Debe seleccionar el cliente correspondiente';
      }

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('marca/save', this.id)
            .then(() => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      }
    },
    goList() {
      this.$router.push({ name: "Marcas" });
    },
    seleccionarCliente() {
      if (this.cliente) {
        this.$store.dispatch('marca/setCliente', null)
          .catch(error => this.showErrorMsj(error))
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.$refs.searchClienteModal.hide();

      this.$store.dispatch('marca/setCliente', cliente)
          .catch(error => this.showErrorMsj(error))

      if (this.cliente) {
        this.clienteValido = null;
        this.clienteInvalidoMsj = '';
      }
    },
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
